<!-- onlineSubmission -->
<template>
  <div class="onlineSubmission">
    <el-form-item label="在线投稿：" prop="onlineSubmission">
      <el-input v-model="ruleForm.onlineSubmission" type="text" class="fl" style="width: 50%;" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'onlineSubmission',
  data() {
    return {}
  },
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
